module.exports = {
  become_our_partner: 'Become our partner',
  select_language: 'Choose the language:',
  privacy_intro_title: 'Privacy Policy',
  privacy_intro_paragraph:
    'This privacy notice informs you about how we protect your personal data and the measures we take to secure it.',
  privacy_paragraph_1:
    'Here you can discover what information we use to provide our suite of transportation services, how we use your data to ensure your safety, and the choices and controls available to you.\n\nThis notice also outlines all possible rights you have regarding the privacy of your data. Data protection rules are in place to protect all parties involved.',
  privacy_paragraph_2:
    'The term ‘we’ refers to the company Nobel, incorporated and registered under the laws of the government. The term ‘you’ refers to the individuals using our application service to request, hire, and/or receive a transportation service.',

  personal_data_title: '1. Personal Data We Process',
  personal_data_paragraph:
    'We only process the information necessary for your needs on our marketplace. This ensures we provide the best possible service for what you are looking to achieve.',

  contact_details_title: 'Contact Details:',
  contact_details_paragraph:
    'We will ask for your personal details like name, phone number, and email address so that we can best assist you. Profile information: We collect some data to help you build your profile, such as saved addresses and language preferences. Some of our services require additional details like your driver’s license number.',

  geolocation_title: 'Geolocation:',
  geolocation_paragraph:
    'By accessing your location, we are able to offer a list of services at your location, such as local transport options. This will show you the estimated journey time with different expenditure options. There is also information about your destination and traffic conditions.',

  payment_details_title: 'Payment Details:',
  payment_details_paragraph:
    'Information about the payment method used, such as the amount charged and the card used.',

  in_app_communication_title: 'In-App Communication Records:',
  in_app_communication_paragraph:
    'We regularly monitor how you interact with our app to ensure we are providing top-tier service. We also keep a record of your in-app chats so we can easily get back in touch if needed.',

  limited_identification_data_title: 'Limited Identification Data:',
  limited_identification_data_paragraph:
    'We collect the IP address of the device on which the app has been installed.',

  ride_data_title: 'Ride Data:',
  ride_data_paragraph:
    'The data we collect about your use of the service, such as journey time, route taken, etc. These timestamps and statistics allow us to schedule easily and are valuable for ensuring driver safety.',

  in_app_message_data_title: 'In-App Message Data:',
  in_app_message_data_paragraph:
    'Our in-app chat collects information regarding the date, time, and content of your communication with a driver. User image: For verification purposes, our app stores user profile images at https://nobel.adminkloud.com/public Usage Data.',

  platform_data_collection:
    'Using the platform will automatically collect data.',
  usage_data_paragraph1:
    'Usage data is information about your device, browser, and website activity. It can tell us things like what type of device you are visiting from, the operating system, version / iTunes version number of your browser (when available), pages you visit for customer support on our website, and off-premise services like hardware and software inventory management.',
  usage_data_paragraph2:
    "When visiting our website and using the mobile app, we may collect certain information automatically without any further human interaction. This includes but is not limited to IP address, device type, device ID number, your device's operating system, network state, and your current location. Even when the app is not being used, the device may still fetch your location and provide ride request capability.",

  website_app_visit_data:
    'We collect information about your visits to our website or use of our app, including any mobile device you use.',

  cookies_tracking_technologies_title: 'Tracking Technologies and Cookies',
  cookies_tracking_technologies_paragraph:
    'We use cookies, beacons, tags, and scripts to track activity on our service and store certain information. These technologies allow us to collect and analyze data for improved performance and better user experience.',

  browser_cookie_options:
    "Your internet browser allows you the option of telling it which type of cookies you do or don't accept. Without this capability, some parts of our website may not function properly.",

  persistent_session_cookies:
    'Cookies can be either ‘Persistent’ or ‘Session’ Cookies. The difference between the two is that Persistent Cookies remain on a personal computer or mobile device even when the user closes their web browser, while Session Cookies are deleted as soon as they are no longer in use.',

  cookies_usage_purpose:
    'We use both session and persistent Cookies for the purposes set out below:',

  necessary_essential_cookies: 'Necessary / Essential Cookies',
  session_cookies: 'Type: Session Cookies<br />Administered by: Us',

  cookies_purpose_title: 'Purpose:',
  cookies_purpose_paragraph:
    'Cookies are used to authenticate users and prevent fraud. They help you navigate through the website and use a few of the services available to you. Cookies allow us to provide you with the services you have requested, which is important for our business. Without them, we cannot provide these services and would have trouble doing so.',

  cookies_policy_notice_title: 'Cookies Policy / Notice Acceptance Cookies',
  persistent_cookies: 'Type: Persistent Cookies<br />Administered by: Us',

  cookies_acceptance_paragraph:
    'These cookies identify whether or not a visitor has accepted the website’s use of cookies.',

  functionality_cookies_paragraph:
    'Functionality Cookies allow you to have a personalized experience across our website. They help us remember your preferences, view your account details, and more. These Cookies are used on the site to provide you with a more enjoyable experience and allow us to avoid asking for your preferences again.',

  cookies_functionality_paragraph:
    'For more information about the cookies we use and your choices regarding cookies, please visit our Cookies Policy.',

  cookies_more_info:
    'This is the Cookies Policy which outlines our cookies and your choices.',

  purpose_of_processing_title: '2. Purpose of the processing',
  purpose_of_processing_paragraph_1:
    'We process your personal data so we can provide you with the services you needed more efficiently:',
  connect_driver_title: 'To connect you with a driver:',
  connect_driver_paragraph:
    'We collect personal data so we can connect with users who are looking to be picked up and dropped off. These services include cars, bikes, and scooters that are available in areas close by. The instant messages the app uses can be used for customer service and to resolve disputes between drivers and riders. This is also helpful when they use that data to improve their products and services, as well as analyze it.',
  track_ride_title: 'We help you keep track of your ride:',
  track_ride_paragraph:
    "We help drivers congregate at specific locations and show them where the passengers they are picking up or dropping off are located. Drivers can also keep track of the route on their monitor to save time & effort, and make sure they have both their phone number and geolocation nearby so that they never miss a call or text from riders. This data is collected only when the app is activated (in use). Drivers in some countries cannot see the passenger's phone number on the app after the app has been closed. This is done to avoid personal information from being accessible to drivers.",
  smooth_journey_title: 'To make sure your smooth journey:',
  smooth_journey_paragraph:
    'Geolocation data is used to automatically get employees to their destinations and reduce the loss of time incurred by getting someone in the wrong location. It also helps ensure billings are correct.',
  app_performance_title: 'We make sure the optimal app performance:',
  app_performance_paragraph:
    'We use your contact information to notify you of any changes to our app. We appreciate you continuing to use our service, and these updates will help you make sure you are using the latest version of our service. We collect limited data from your device to improve our service (IP address and data that helps you connect with the internet). These checks help keep your account safe and verify your authentication.',
  quick_ride_title:
    'To make sure to offer a quick, cheap, and most convenient ride to you:',
  quick_ride_paragraph:
    'We collect data on the routes taken by our passengers and riders to analyze geographic coverage. This feature allows us to find the most efficient routes for drivers and our scooters. It also helps make sure that our employees are near customers.',
  collect_payment_title: 'We collect your payment:',
  collect_payment_paragraph:
    'We obtain payment details to process passenger payments for drivers who use our ride-hailing app. These are usually used in transactions such as rideshare and cab.',
  maintain_standards_title: 'We maintain and promote standards:',
  maintain_standards_paragraph:
    'We collect data on journeys, such as whether a journey has concluded, or when it happened. Through this, we encourage customer safety and compliance with our terms and conditions. We also want to make sure that everyone comes away from their experience with us feeling satisfied. Customer service is an important aspect of any business, and feedback on the quality of your customer support can be helpful. It allows you to resolve disputes, as well as instill a sense that your company cares about the customer’s experience.',
  keep_informed_title: 'We keep you informed:',
  keep_informed_paragraph:
    "We'll use your name, phone number, and email address to let you know if your journey is complete or to send you other trip-related information.",

  legal_basis_title: '3. Legal Basis',
  legal_basis_paragraph_1:
    'We are allowed to use your data in the ways described above if you have a proper reason for doing so. Your information always comes with an explicit need for you, and we make sure that any usage is justified.',
  legal_basis_paragraph_2:
    'We process your personal data to create the personalized service you want. Personal data may be processed to meet our terms and conditions, in order to give you an unparalleled service.',
  legal_basis_paragraph_3:
    'We confirm with you whether we need your personal data in order to process your request or if it falls under legitimate interest. Our legitimate interests include providing an innovative, personalized, and safe service to our passengers and partners. This is at the expense of other interests - including being profitable. Our legitimate interests in our company include things like investigating fraud and other malicious activity, maintaining the security of our systems, and responding to potential criminal activity.',
  legal_basis_paragraph_4: 'We sometimes rely on alternative legal bases when:',
  legal_basis_paragraph_5:
    'Compliance with a legal obligation such as processing data when required can be beneficial. It happens, for example, if there is a valid legal request.',
  legal_basis_paragraph_6:
    'In the event of an emergency or when there is a threat to life.',
  legal_basis_paragraph_7:
    'We always strive for transparency in all of our contact with you. This includes requirements for providing consent to specific uses as well as information about how we review, use, and retain your content metadata.',
  legal_basis_paragraph_8:
    "Getting personal information to complete a contract is important and may allow the company to avoid certain legal consequences. It might also mean that they are not able to provide you with services. When you download our App, we collect and process your personal data, such as location information, so that drivers can find you in a timely manner. Refusing to share your location will cause it to be unavailable for driver directions and when looking for reservations. We will not let you sign up or use your account if there's a reasonable suspicion that you're trying to get around the obligations.",

  recipients_title: '4. Recipients',
  recipients_paragraph_1:
    "We only work with trusted partners and authorities. We always share what is necessary and nothing more. We know that data can be valuable, so we don't sell your personal information to companies that may use it against you.",
  recipients_paragraph_2:
    "When a ride-on is requested, the company shares your personal data with the driver. This includes all name, contact number, and location data, as well as other demographic information. After availing the transportation service, your information will remain visible to the driver for 24-48 hours. This is important because it allows supervisors who may have an issue like something left in the car to contact their driver and get the issue resolved with that passenger. Riders give up-to-date feedback on their rides using our app. The data is anonymous and made private between you and the company. So even if someone gives you a bad rating, they can't use your input against you or it will no longer be accurate. It is in some cases legally compelled to share information with external recipients, such as when a court orders us or when we cooperate with a data protection supervisory authority. We often perform these responses when we have a good-faith belief that the response is required by law in that jurisdiction, when it furthers a public interest task, affects users in that jurisdiction, and is consistent with our Terms of Service. We have a strong legal basis to share the information and will document our decision by providing a justification.",
  security_title: '5. Security of Your Personal Data',
  security_paragraph_1:
    'Data security is one of our top priorities, but your data may not be completely secure. As we strive to use industry-accepted means of data protection, keep in mind that no method of transmission over the internet or method of electronic storage would be 100% secure.',

  children_privacy_title: "6. Children's Privacy",
  children_privacy_paragraph_1:
    'We do not address anyone under the age of 13. We do not knowingly collect personal information from anyone under the age of 13. If you are a parent or guardian and you realize that your child has provided us with personal data, please contact us. We are aware that we collected Personal Data from anyone under the age of 13 without verifying parental consent on our servers. If this happens, we remove the information from our servers.',
  children_privacy_paragraph_2:
    'Some of our services are only available to users over 13. In certain cases, this means we might not be able to provide certain features or functionality of the service to these younger users.',
  children_privacy_paragraph_3:
    "If we are required by law to seek your parent's consent in order for us to collect and process any personal data, we will not be able to do so unless you give us their permission.",

  links_title: '7. Links to Other Websites',
  links_paragraph_1:
    "We may link to other websites that aren't operated by us. If you click on a third party link, you will be taken to that website's site. It’s important that you read the privacy policy for every site you visit.",
  links_paragraph_2:
    'We do not censor any 3rd party sites or the content on those sites. We have no control over and assume no responsibility for the content, protections, privacy policies, or practices of any third party site with which we are linked.',

  changes_title: '8. Changes to this Privacy Policy',
  changes_paragraph_1:
    "We will update our Privacy Policy from time to time. If a change is made, we'll notify You via the Forum or via other means.",
  changes_paragraph_2:
    "Email or a prominent notice before the change takes effect will be sent to provide notification of what changes are coming, as well as providing an update with the 'Last updated' date at the top of this Privacy Policy.",
  changes_paragraph_3:
    'Visitors should periodically check the privacy policy for any changes that have been posted on this site. Changes to the privacy policy will remain in effect until a new copy is posted to this page.',

  rights_title: '9. Your rights and controls',
  rights_paragraph_1:
    "We want you to remain in control of your personal data. We provide you with the necessary controls from within the app to view each and every bit of information we collect on our users including their profile data and trip history. We've also got some in-app settings, such as marketing opt-ins, and clear cookie consent controls on our app.",
  rights_paragraph_2: 'Your right of access',
  rights_paragraph_3:
    "You have the right to ask for a copy of any personal information we've collected about you. We may not always provide all the information you request from us because we have to balance our rights against those of others.",
  rights_paragraph_4: 'Your right to rectification',
  rights_paragraph_5:
    'You can get better assistance with all your personal data on the app. You also have the right to ask us to update or complete any of the records that you believe are incomplete. This way, you have an easier time getting everything booted up and running smoothly.',
  rights_paragraph_6: 'Your right to erasure',
  rights_paragraph_7:
    "You can request that your personal information that's stored on our servers be removed in certain circumstances.",
  rights_paragraph_8: 'Your right to restriction of processing',
  rights_paragraph_9:
    'You have the right to ask us to restrict the processing of your information in certain circumstances. For example, if you file a complaint with the company or if you would like to exercise legal rights (like claiming compensation for damages or your data has been hacked).',
  rights_paragraph_10: 'Your right to object to processing',
  rights_paragraph_11:
    "We're processing your data on the basis of legitimate interests. If you want to object, you can tell us that and ask for a person to review it.",

  retention_title: '10. Retention',
  retention_paragraph_1:
    "Our app stores users' data only for as long as it needs to comply with their policies. All categories of data (e.g., billing, location) are stored for different periods of time depending on the type (e.g., 6 weeks for billing data, 12 months for location data).",
  retention_paragraph_2:
    'After having an active account with our service, your personal data is stored with us for as long as you use our services. You can permanently deactivate your account or delete your personal data through the app as needed. If your account is closed, personal data will be deleted according to our retention schedules and rules. Data on transportation services provided to passengers will be stored for three years after the last journey and; data on other accounting purposes will be stored for seven years after the last journey.',
  retention_paragraph_3:
    "We maintain all necessary data for internal, legal, and regulatory requirements to ensure we're a compliant company. In case of payment claims, your personal information will be retained unless it is satisfied or the claim expires. The personal journey history and usage data of any individual will be stored for 3 years after which it will be rendered private by anonymizing the data. Information about You is stored securely and will be used only as needed for those purposes. We store the data necessary for our business specifically to the company’s purposes, which might change over time. The information will not be collected or shared with any other party. At times, We may need to retain your Data to comply with our legal obligations and enforce our agreements and policies.",
  retention_paragraph_4:
    "The Company will also retain User Data for internal analysis purposes. User data is retained for a shorter period of time except when it is used to strengthen the security or to improve the functionality of our service, or we're legally obligated to keep this data for longer periods.",

  contact_title: 'Contact Us',
  contact_paragraph_1:
    'If you have any questions about this Privacy Policy, You can contact us: ',
  contact_paragraph_2: 'By email: manuelnobelapp@gmail.com',

  termsAndConditions_title: 'Terms & Conditions',
  termsAndConditions_intro_title: 'Welcome to the NOBEL app!',
  termsAndConditions_intro_paragraph:
    'NOBEL presents to you these General Terms and Conditions relating to the provision of services, as well as the information, elements, data, and requirements contained therein and which are the property of Nobel-app, based at Petrus Huysegomsstraat 5, Sint-Pieters-Leeuw, with company number: 0744.455.5, hereinafter briefly referred to as "NOBEL".',
  aboutTheAppTitle: 'About the NOBEL App',
  aboutTheAppIntro:
    'To understand these Terms & Conditions, it is necessary to understand:',
  appDefinition: {
    title: '1.1 "NOBEL App (hereinafter referred to as the App)"',
    description:
      'The software that offers a set of services and enables their contract electronically and remotely;',
  },
  termsAndConditionsDefinition: {
    title: '1.2 "Terms & Conditions"',
    description:
      'The general terms and conditions that determine the access and use of the NOBEL App by its users;',
  },
  personalDataDefinition: {
    title: '1.3 "Personal Data"',
    description:
      'Means information relating to an identified or identifiable natural person ("Data Subject"); a natural person is considered identifiable if he or she can be identified, directly or indirectly, in particular by reference to an identifier, such as a name, an identification number, location data (see Privacy Policy);',
  },
  serviceProviderDefinition: {
    title: '1.4 "Service Provider"',
    description:
      'A natural or legal person with whom NOBEL has a commercial agreement under which it offers its services on the Application, and who will provide services directly to the User;',
  },
  provisionOfServicesDefinition: {
    title: '1.5 "Provision of Services"',
    description:
      'The services available on the NOBEL App and the contract concluded between the Service Providers and the Users;',
  },
  userDefinition: {
    title: '1.6 "User"',
    description:
      'A natural person, over the age of 18, who accesses and uses the Application in accordance with these Terms and Conditions;',
  },
  contractDefinition: {
    title: '1.7 "Contract"',
    description:
      'Means a commercial agreement between the Service Provider and NOBEL, which includes:',
  },
  contractDetails: {
    termsAndConditions: '1.7.1 These Terms & Conditions;',
    specialTerms:
      '1.7.2 Special terms disclosed in the NOBEL App, e.g. regarding prices or description of services;',
    additionalTerms:
      '1.7.3 Additional Terms & Conditions or documents to be signed in the future between the Service Provider and NOBEL.',
  },
  priceDefinition: {
    title: '1.8 "Price"',
    description:
      'The amount that the User must pay to the Service Provider for the Services provided, as well as the amount to be withheld for payment of the intermediation by NOBEL.',
  },
  intermediationFeesDefinition: {
    title: '1.9 "Intermediation Fees"',
    description:
      'Means the fees that the Service Provider must pay to NOBEL for the use of the Platform.',
  },
  paymentsDefinition: {
    title: '1.10 "Payments"',
    description:
      'Card, payment system and other payment methods chosen by users via NOBEL to pay for the provision of services.',
  },
  acceptanceAndConclusionTitle:
    'Acceptance and conclusion of the contract with NOBEL',
  acceptanceAndConclusion: {
    item1:
      '2.1 To access the NOBEL app, you must install the app on your mobile device (whether a smartphone or tablet, running iOS or Android).',
    item2:
      '2.2 The download and installation of the NOBEL App on your mobile device is free of charge, although there may be costs associated with the use of the telecommunications network and mobile data, which are entirely and exclusively borne by the Service Provider and must be paid by the Service Provider according to the terms of the contract with the relevant telecommunications operator.',
    item3:
      '2.3 After the creation of the account, authentication is carried out, which consists of sending the user, by SMS or e-mail, a security code, personal, confidential and non-transferable. The service provider is responsible for its safekeeping, confidentiality and security.',
    item4:
      '2.4 The Service Provider shall keep its credentials confidential and limit access to its account, including by protecting its credentials from loss, theft or misuse. Any loss of credentials must be reported to NOBEL.',
    item5:
      '2.5 Any damage resulting from the unauthorised use of the Identifiers is the sole responsibility of the Service Provider.',
    item6: '2.6 The Service Provider represents and warrants that it:',
    item6_1:
      '2.6.1 Has carefully considered, understood, and agreed to be bound by this Agreement, including all obligations arising hereunder for the Service Provider as described herein;',
    item6_2:
      "2.6.2 Will not allow others to use the Service Provider's account, or to transfer or assign it to other persons without the express written permission of NOBEL;",
    item6_3:
      '2.6.3 Will not copy or distribute the App Software, or any other NOBEL Content without the prior written permission of NOBEL.',
    item7:
      "2.7 In the event of a breach of any applicable legal provision, these Terms & Conditions or other applicable contractual provisions, NOBEL reserves the right to suspend or terminate the Service Provider's account or take any other action it deems appropriate in its sole discretion.",
  },
  contractualRelationshipTitle:
    'Contractual relationship between the Service Provider and the User',
  contractualRelationship: {
    item1:
      '3.1 The Service Provider agrees that it may enter into a Service Provision Agreement with the User.',
    item2:
      '3.2 The Services are provided by the Service Provider as an independent business and therefore the Service Provider shall not be considered an employee or worker or equivalent vis-à-vis NOBEL, in respect of the services provided.',
    item3:
      '3.3 Notwithstanding the fact that NOBEL is not a party to the contractual relationship between the Service Provider and the User, the Service Provider undertakes to:',
    item3_1:
      '3.3.1 Take out an Occupational Accident Insurance policy (in accordance with Law No. ______;',
    item3_2:
      '3.3.2 Ensuring occupational safety and health (in accordance with the general provisions of Law No. ______);',
    item3_3:
      '3.3.3 Ensure that all its employees and/or service providers are fit to work (in accordance with the Ordinance_____________);',
    item3_4:
      '3.3.4 Not to provide services under the influence of alcohol or drugs and not to take measures that are harmful or likely to harm the safety of Users or third parties, which could affect the image and credibility of NOBEL;',
    item3_5: '3.3.5 Conduct yourself diligently, avoiding risky behaviour;',
    item3_6:
      '3.3.6 Hold liability insurance and any other insurance required in the applicable jurisdiction for the provision of home services;',
    item3_7:
      '3.3.7 Have all the equipment, materials and means necessary for the Provision of Services, the costs of which will be borne by him/herself, including fuel for travel.',
  },

  priceTitle: 'Price',
  price: {
    item1:
      '4.1 The price of the Service is set in the NOBEL app, as well as the applicable statutory taxes. Likewise, the Service Provider will be able to see the amount associated with the 30% intermediation percentage that will be paid to NOBEL and which will be automatically retained.',
    item2:
      '4.2 On the other hand, the NOBEL App also provides a price for each additional hour of service, which must be activated by the Service Provider in cases where, due to an incorrect, inaccurate or insufficient description of the User, the work turns out to be more complex than requested. The User has the option of choosing whether to continue the provision of services or to refuse it.',
    item3:
      '4.3 If the User does not accept the new price indicated, the provision of services will be cancelled, giving rise to a payment in the amount of €30.',
  },
  meansOfPaymentTitle: 'Means of Payment',
  meansOfPayment: {
    item1:
      '5.1 The Service Provider undertakes to provide valid, up-to-date and complete credit or debit card information when registering for the NOBEL App.',
    item2:
      '5.2 Payments will be made every 15 days, so that NOBEL can guarantee the effectiveness and success of the Services provided.',
    item3:
      "5.3 If NOBEL is unable to charge any amount due for a Service or any other amount from a User's credit or debit card, we reserve the right to temporarily suspend or disable all or part of their access to the Application. This does not affect any other rights or remedies available to us (as a debt collector on behalf of the Service Provider), and to the Service Provider.",
    item4:
      "5.4 Payments are made by an independent third party who will retain the amount of the service before it is performed, this amount being debited from the User's credit card.",
    item5:
      '5.5 The invoice will be sent by NOBEL, in digital form, to the e-mail address provided by the Service Provider, after confirmation that the Service Provision has been successfully completed.',
  },
  userIdentificationTitle: 'User Identification',
  userIdentification: {
    item1:
      '6.1 Before commencing the Provision of Services, the Service Provider undertakes to go to the address indicated and identify the User.',
    item2:
      '6.2 If the Service Provider makes a mistake in identifying the User and the payment is taken from a person who did not receive the service, NOBEL will refund the amount to the User. In this case, the Service Provider will not be entitled to the rate corresponding to the Provision of Services made and will bear the costs of reimbursement to NOBEL.',
  },
  Responsibilitytitle: 'Responsibility',
  Responsibility: {
    item1:
      '7.1 NOBEL is not a party, in any way, to the contractually established relationship between the User and the Service Provider. Consequently, they acknowledge that no liability can be attributed to it, in particular with regard to the performance of the contract and the fulfilment of the contractual obligations of the parties.',
    item2:
      '7.2 Similarly, NOBEL cannot be held liable for the non-performance of a contract by either party or for extra-contractual liability, as well as for any loss or damage that may result therefrom for either party.',
    item3:
      '7.3 NOBEL does not guarantee the permanent or uninterrupted operation of the NOBEL App. Thus, it cannot be held liable for the impossibility of its use or for any damage or prejudice that may result from it:',
    item3_1:
      '7.3.1 Difficulties in using the App caused in particular by delays, interruptions, errors, interference or suspension of communications, viruses, bugs or malfunctions;',
    item3_2:
      '7.3.2 Delays caused by deficiencies or overloads of Internet traffic or other electronic systems;',
    item3_3:
      '7.3.3 Illegitimate acts of third parties, errors or security defects due to the use of obsolete or insecure equipment or browsers, failures of the electronic communications services used by the Service Provider, as well as damages, errors and inaccuracies that may result from their malfunction.',
    item4:
      '7.4 The Service Provider assumes full responsibility for its acts or omissions and the consequences thereof, releasing NOBEL from any liability for any direct or indirect action, whether incidental or criminal, related to any misuse or illegal use of the NOBEL App.',
    item5:
      '7.5 The Service Provider acknowledges and agrees that no liability, direct or indirect, can be attributed to NOBEL as a result of the use of the NOBEL App.',
    item6:
      '7.6 The Service Provider is responsible for its use of the NOBEL App, even if it is made by third parties, with or without its authorisation. However, if a transaction is proven to have been carried out by a third party, it is presumed that this was consented to or negligently facilitated by the Service Provider.',
    item7:
      '7.7 The Service Provider and NOBEL agree that the computer recording or its reproduction on any medium, including paper, constitutes proof of the operations carried out in accordance with these Terms and Conditions.',
    item8:
      '7.8 NOBEL assumes no liability for any loss or damage that the Service Provider may suffer in connection with the contract entered into with the User or resulting from the use of the NOBEL App, including, without limitation:',
    item8_1: '7.8.1 Any accident occurring in the provision of services;',
    item8_2: '7.8.2 Any direct or indirect material damage or monetary loss;',
    item8_3: '7.8.3 Loss of profits or anticipated profits;',
    item8_4:
      '7.8.4 Loss of business, contracts, contacts, prestige, reputation and any loss that may result from business interruption;',
    item8_5: '7.8.5 Loss or inaccuracy of data;',
    item8_6: '7.8.6 Any other indirect or consequential damages.',
  },
  Sanctions: {
    title: 'Sanctions',
    description:
      'NOBEL reserves the right to exclude from the use of the NOBEL app, immediately and without prior notice, any Service Provider who:',
    item1:
      '8.1 Violates or is suspected of having violated any of the provisions of these Terms & Conditions and the associated Privacy Policy;',
    item2:
      '8.2 Uses the NOBEL App with false, inaccurate or incomplete registration data;',
    item3: '8.3 Fraudulently uses the NOBEL App;',
    item4:
      '8.4 Manipulates, alters, deletes or deletes any data, programs or computer systems associated with the NOBEL App;',
    item5:
      '8.5 Directly contacts Users of the NOBEL App, by any means, for the purpose of establishing partnerships or business relationships;',
    item6:
      '8.6 Has been reported for fraudulent or harmful behaviour that may affect the image and credibility of NOBEL.',
  },
  IntellectualPropertyRightsTitle: 'Intellectual Property Rights',
  IntellectualPropertyRights: {
    item1:
      '9.1 By installing and using the NOBEL App, the Service Provider acknowledges and agrees that the intellectual property rights to all content of the NOBEL App belong to NOBEL, including the information, tools, graphic designs, all media components, the logo and all figures or texts.',
    item2:
      '9.2 The total or partial reproduction of any information or content of the NOBEL App, its rental or sale, without the prior permission of NOBEL is prohibited.',
    item3:
      '9.3 The distinctive signs of the NOBEL app are protected and may not be used by third parties without the prior and express consent of NOBEL.',
    item4:
      "9.4 It is strictly prohibited, the Service Provider from attempting to access, modify, reproduce, distribute, sell, license or copy NOBEL's content and intellectual property rights, whether in whole or in part.",
    item5:
      '9.5 All intellectual property rights in the Software, its content and any associated documentation, in any part of the world, belong to NOBEL or its licensors and may not be copied, distributed, downloaded, republished, decompiled, disassembled or transmitted in any form without the prior written permission of NOBEL.',
  },
  UserRatingsTitle: 'User Ratings',
  UserRatings: {
    item1:
      '10.1 NOBEL aims to ensure the quality, efficiency and success of the services it offers on its platform to users. To this end, the evaluation of the user is a decisive element for the continuation of the contractual relationship between NOBEL and the Service Provider.',
    item2:
      '10.2 The user can leave comments and rate the quality of the welcome and service provided from 1 to 5.',
    item3:
      '10.3 In the event that the Service Provider is evaluated three times with scores below 3 on a scale of 1 to 5, it may be contacted by NOBEL to provide clarification. Without prejudice to the foregoing, NOBEL reserves the right to terminate the contract between NOBEL and the Service Provider immediately and without notice.',
  },
  TermAndTerminationTitle: 'Term and Termination',
  TermAndTermination: {
    item1:
      "11.1 The Service Provider may terminate the Agreement at any time by sending written notice to NOBEL with at least 15 (fifteen) days' notice.",
    item2:
      "11.2 NOBEL may terminate the Agreement at any time and for any reason, at NOBEL's sole discretion, by notifying the Service Provider with at least 5 (five) days' notice.",
    item3:
      '11.3 NOBEL reserves the right to terminate the Agreement and block access to the Service Provider without prior notice in the event of a breach of the Agreement and/or any applicable law or regulation by the Service Provider.',
    item4:
      '11.4 After the termination of this Agreement for any reason, all rights granted to the Service Provider under this Agreement shall cease immediately, and the Service Provider shall cease all activities permitted by this Agreement.',
  },
  DisputeResolutionTitle: 'Dispute Resolution',
  DisputeResolution: {
    item1:
      '12.1 In the event of a dispute relating to the provision of services, please contact us first at the following email address: info@nobel-app.com.',
    item2:
      '12.2 In the unlikely event that a dispute cannot be resolved amicably, we will discuss and agree with the Service Provider on the most effective way to resolve the dispute.',
  },
  FinalTransitionalProvisionsTitle: 'Final and Transitional Provisions',
  FinalTransitionalProvisions: {
    item1:
      '13.1 NOBEL reserves the right to unilaterally change the layout and configuration of the NOBEL App at any time and without prior notice.',
    item2:
      '13.2 NOBEL reserves the right to update these Terms and Conditions from time to time.',
    item3:
      '13.3 Changes or updates may be justified by the need to implement new functionalities of the NOBEL App as well as by changes in the applicable legislation.',
    item4:
      '13.4 NOBEL will endeavour to notify the Service Providers of changes or updates to these Terms and Conditions at least 14 (fourteen) days in advance.',
    item5:
      '13.5 If any provision of these Terms and Conditions is held to be unenforceable or unenforceable, this shall not affect the enforceability and validity of the remaining provisions.',
  },
  ApplicableLawAndJurisdictionTitle: 'Applicable law and jurisdiction',
  ApplicableLawAndJurisdiction: {
    item1:
      '14.1 The NOBEL application, as well as these General Terms and Conditions, are subject to the legislation in force in the Belgian legal system.',
    item2:
      '14.2 NOBEL and the user accept and agree that any dispute arising out of these Terms and Conditions, as well as the Privacy Policy which forms an integral part of them, shall be decided by the Court________________________________',
  },
  ItShouldBeAdded: 'It should be added:',
  ServiceProviderWorkNonCompliance:
    'In the event that the Service Provider does not carry out the work in accordance with the rules of the trade and quality standards required by NOBEL, we expressly reserve the right not to proceed with the payment of the service in question.',
  QualifiedServiceProviderSubstitution:
    'NOBEL also reserves the right to send another qualified service provider to correct or complete the work initially requested.',
  QualityStandardsSatisfaction:
    'This measure aims to ensure the satisfaction of our users and the maintenance of the high standards of quality that NOBEL is committed to providing.',
  AgreementAcknowledgment:
    'By agreeing to these Terms and Conditions, the Service Provider acknowledges and accepts this provision, understanding that non-compliance with quality requirements may result in non-remuneration for its services and the implementation of corrective measures by NOBEL.',
  about_title: 'About',
  AboutDescription:
    'Welcome to Nobel, where convenience meets expertise! At Nobel, we understand the challenges of maintaining a home or business, and we believe that everyone deserves access to reliable and skilled service professionals. Our platform was born out of the vision to create a seamless connection between service seekers and providers, making home services more accessible, efficient, and enjoyable.',
  MissionDescription:
    "Our mission is to simplify your life by providing a one-stop solution for all your home service needs. Whether it's fixing a leaky faucet, refreshing your living space with a thorough cleaning, or solving electrical issues, Nobel is here to connect you with verified professionals who deliver top-notch services.",

  whyNobelTitle: 'Why Nobel',
  whatMakesUsBetter: 'What makes us better than the rest.',

  whyNobel: [
    {
      title: 'Quality You Can Trust',
      description:
        'We prioritize your satisfaction and peace of mind. All our service providers undergo a rigorous vetting process to ensure they meet the highest standards of professionalism and expertise.',
    },
    {
      title: 'Convenience at Your Fingertips',
      description:
        'With just a few taps on your smartphone, you can book a variety of services and have skilled professionals at your doorstep. Say goodbye to the hassle of searching and scheduling - Nobel has it all covered.',
    },
    {
      title: 'Safety First',
      description:
        'Your safety is our priority. Our platform ensures that all transactions are secure, and we provide real-time tracking of service providers so you know exactly when to expect them.',
    },
    {
      title: 'Diverse Services',
      description:
        'From plumbing and electrical work to cleaning and gardening, we offer a comprehensive range of services to cater to your unique needs. Whatever the task, we have the right professional for you.',
    },
    {
      title: 'User-Friendly Experience',
      description:
        'Our app is designed to be user-friendly, allowing you to easily navigate, book services, and communicate with service providers. We value your time, and our platform is built to make the entire process seamless.',
    },
    {
      title: 'Reliable Support',
      description:
        'We are committed to providing exceptional customer support. Our dedicated team is always ready to assist you with any inquiries, ensuring a smooth and stress-free experience.',
    },
  ],
  joinSection: {
    title: 'Join the Nobel Community',
    description:
      "Whether you're a service seeker looking for reliable professionals or a skilled service provider wanting to grow your business, Nobel welcomes you to join our community. Together, we're redefining the way home services are delivered, making life simpler and more enjoyable for everyone.",
  },
  sloganSection: {
    title: 'Experience the convenience, reliability, and excellence of Nobel.',
    subtitle: 'Download the app today and discover a new era of home services.',
  },
  product: 'Product',
  customer_app: 'Customer App',
  provider_app: 'Provider App',

  home_services: {
    line1: 'Home services at',
    line2: 'your Doorsteps.',
  },

  rights_reserved: 'Nobel. All rights reserved.',
  help: 'Help',
  delivery_message:
    'Fast, reliable, and guaranteed to meet your expectations, delivered right to your doorstep.',
  home_services_title: 'Reliable Home Services',
  home_services_subtitle: 'Just a Tap Away!',
  services__top_title: 'All of the Services',
  join_nobel_team:
    'Are you an experienced professional and would you like to belong to the Nobel team of technicians? Sign up now!',
  work_with_us: 'Do you want to work with us?',
  tell_us: 'Tell us what you are looking for',
  your_name: 'Name',
  your_email: 'Email',
  your_subject: 'Subject',
  your_message: 'Message',
  submitting: 'Submitting...',
  success: 'Submission successful!',
  submit_request: 'Submit Request',
  something_went_wrong: 'Something went wrong, try again later.',
  home_title: 'Home',
  name_required: 'Name is required',
  email_required: 'Email is required',
  invalid_email: 'Invalid email format',
  message_required: 'Message is required',
  captcha_required: 'Captcha is required',
  subject_required: 'Subject is required',
  name_minlength: 'Name must be at least 3 characters long.',
  name_maxlength: 'Name must be at least 50 characters long.',
  subject_minlength: 'Subject must be at least 3 characters long.',
  subject_maxlenght: 'Subject cannot exceed 30 characters.',
  message_minlength: 'Message must be at least 10 characters long.',
  message_maxlength: 'Message cannot exceed 500 characters.',
  regex_name: 'Verify the name',
  why_nobel: 'Why Nobel',
  what_makes_us: 'What makes us better than the rest.',

  faq: {
    general: {
      title: 'General',
      questions: [
        {
          question: 'What is Nobel?',
          answer:
            'Nobel is a convenient platform that connects you with trusted and skilled service providers for various home maintenance and repair needs, such as plumbing, electrical work, cleaning, and more.',
        },
        {
          question: 'How does Nobel work?',
          answer:
            'Simply download the app or visit our website, select the service you need, choose a provider, and schedule an appointment at your convenience.',
        },
        {
          question: 'Is Nobel available in my area?',
          answer:
            'We are constantly expanding our service areas. Enter your location in the app or website to check availability.',
        },
      ],
    },
    booking: {
      title: 'Booking & Services',
      questions: [
        {
          question: 'How do I book a service?',
          answer:
            'You can book a service by selecting the category, choosing a service provider, and confirming your appointment. Payment can be made securely through the app.',
        },
        {
          question: 'Can I schedule a service in advance?',
          answer:
            'Yes! You can book services for the same day or schedule them for a later date based on your availability.',
        },
        {
          question: 'What services do you offer?',
          answer:
            'We offer various services including plumbing, electrical work, cleaning, gardening, appliance repair, painting, handyman tasks, and more.',
        },
      ],
    },
    pricing: {
      title: 'Pricing & Payments',
      questions: [
        {
          question: 'How is pricing determined?',
          answer:
            'Pricing depends on the type of service, duration, and complexity. You will see a price estimate before confirming your booking.',
        },
        {
          question: 'What payment methods do you accept?',
          answer:
            'We accept major credit/debit cards, digital wallets, and other secure payment methods available in your region.',
        },
        {
          question: 'Is there a cancellation fee?',
          answer:
            'Cancellations made within a certain time frame are free. However, last-minute cancellations may incur a small fee. Check our cancellation policy for details.',
        },
      ],
    },
    support: {
      title: 'Support & Issues',
      questions: [
        {
          question: "What if I'm not satisfied with the service?",
          answer:
            'Your satisfaction is our priority. If you are not happy with a service, you can contact our support team to resolve the issue.',
        },
        {
          question: 'How do I contact customer support?',
          answer:
            'You can reach us via in-app chat, support email, phone, or our Contact Us form.',
        },
        {
          question: 'Can I reschedule my booking?',
          answer:
            'Yes, you can modify your appointment through the app, depending on the provider’s availability.',
        },
      ],
    },
  },
  servicestoptitle1: "Men's Salon",
  servicestoptitle2: 'Beauty & Salon for women',

  services_list1_top: {
    image01: [
      {
        largeDesc: 'Simple Haircut',
        smallDesc: "Men's Salon",
      },
    ],
    image02: [
      {
        largeDesc: 'Beard Trim',
        smallDesc: "Men's Salon",
      },
    ],
    image03: [
      {
        largeDesc: 'Hair Wash',
        smallDesc: "Men's Salon",
      },
    ],
    image04: [
      {
        largeDesc: 'Facial',
        smallDesc: "Men's Salon",
      },
    ],
    image05: [
      {
        largeDesc: 'Shave',
        smallDesc: "Men's Salon",
      },
    ],
  },

  services_list2_top: {
    image06: [
      {
        largeDesc: 'Pedicure',
        smallDesc: "Women's Beauty & Salon",
      },
    ],
    image07: [
      {
        largeDesc: 'Manicure',
        smallDesc: "Women's Beauty & Salon",
      },
    ],
    image08: [
      {
        largeDesc: 'Hairstyling',
        smallDesc: "Women's Beauty & Salon",
      },
    ],
    image09: [
      {
        largeDesc: 'Body Massage',
        smallDesc: "Women's Beauty & Salon",
      },
    ],
    image10: [
      {
        largeDesc: 'Face Massage',
        smallDesc: "Women's Beauty & Salon",
      },
    ],
  },

  small_title_card1: 'Car Wash',
  big_title_card1: 'Get Squeaky Clean Cars',
  button_explore_card1: 'Explore Now',
  small_title_card2: 'Housekeeping',
  big_title_card2: 'Clean up your house without any hassel',
  button_explore_card2: 'Explore Now',
  services_bottom_title: 'Cleaning & Repairs',

  services_list1_bottom: {
    image11: [
      {
        largeDesc: 'Simple Haircut',
        smallDesc: "Men's Salon",
      },
    ],
    image12: [
      {
        largeDesc: 'Simple Haircut',
        smallDesc: "Men's Salon",
      },
    ],
    image13: [
      {
        largeDesc: 'Simple Haircut',
        smallDesc: "Men's Salon",
      },
    ],
  },
  "delete_account": "Delete Account",
  
  
  "delete_title": "Request Account Deletion",
  "delete_description": "Enter your phone number below to request deletion of your account and all associated data.",
  "delete_phone_label": "Phone Number (with country code)",
  "delete_phone_placeholder": "Enter your phone number with country code",
  "delete_button": "Request Deletion",
  "delete_success": "A deletion confirmation email has been sent.",
  "delete_error": "Unable to process your request. Please check your phone number."



};
